const STORAGE_KEY = "qaCoderPremiumAccess";

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

function writeStore(value) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
}

export function hasPremiumAccess(packId) {
  if (typeof window === "undefined") return false;
  const store = readStore();
  return Boolean(store[packId]?.unlocked);
}

export function getPremiumAccess(packId) {
  if (typeof window === "undefined") return null;
  const store = readStore();
  return store[packId] || null;
}

export function unlockPremiumAccess(packId, purchaseDetails = {}) {
  if (typeof window === "undefined") return null;
  const store = readStore();
  const purchaseId = `QAP-${new Date().getFullYear()}-${Math.floor(100000 + Math.random() * 900000)}`;
  const record = {
    unlocked: true,
    purchaseId,
    unlockedAt: new Date().toISOString(),
    ...purchaseDetails,
  };
  store[packId] = record;
  writeStore(store);
  return record;
}

export function clearPremiumAccess(packId) {
  if (typeof window === "undefined") return;
  const store = readStore();
  delete store[packId];
  writeStore(store);
}
